import React from "react";
// import logo from "../../assets/logo.png"; // We'll need to locate the logo

const AuthLayout = ({ children, title, subtitle }) => {
    return (
        <div className="min-h-screen bg-[#EBF5FF] flex items-center justify-center p-4"> {/* Light blue background like mockup */}
            <div className="bg-white rounded-[2rem] shadow-xl p-8 md:p-12 w-full max-w-md mx-auto text-center relative">
                <div className="flex justify-center mb-6">
                    {/* Placeholder for Logo - assuming image */}
                    <div className="flex items-center gap-2 text-black font-bold text-xl">
                        <img src="/logo.png" alt="Braccet" className="w-8 h-8 object-contain" />
                        <span>Braccet</span>
                    </div>
                </div>

                {title && <h1 className="text-3xl font-bold text-gray-900 mb-2">{title}</h1>}
                {subtitle && <p className="text-gray-500 mb-8">{subtitle}</p>}

                {children}
            </div>
        </div>
    );
};

export default AuthLayout;
